export default [
  { type: "bitzlato", title: "Bitzlato" },
  { type: "whitebit", title: "WhiteBit" },
  { type: "firekassa", title: "Firekassa" },
  { type: "vanilapay", title: "Vanilapay" },
  { type: "okx", title: "OKX" },
  { type: "mixer", title: "Mixer" },
  { type: "operator", title: "Баланс оператора" },
  { type: "garantex", title: "Баланс Garantex" },
  { type: "otc", title: "OTC" },
  { type: "yuan", title: "Юани" }
];



// WEBPACK FOOTER //
// ./src/components/pages/Ledger/components/Balances/balanceTypes.js